<template>
  <div class="weather-settings-add">
    <validation-observer ref="obs" v-slot="ObserverProps">
      <div class="header">
        <div class="title">
          <ul>
            <li id="title-icon">
              <div></div>
              <span>累積気温</span>
            </li>
          </ul>
        </div>
        <!-- <h1 class="title">累積気温</h1> -->
      </div>
      <div class="section">
        <div class="container">
          <dl class="columns">
            <dt>名称</dt>
            <dd>
              <ValidationProvider
                rules="required|max:20"
                immediate
                v-slot="ProviderProps"
              >
                <input type="text" v-model="settingInfo.name" />
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>起算日</dt>
            <dd>
              <ValidationProvider
                rules="required"
                immediate
                v-slot="ProviderProps"
              >
                <input type="date" v-model="settingInfo.datetime" />
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>累積目標値（℃）</dt>
            <dd>
              <ValidationProvider
                rules="required|numeric|between:1,9999"
                immediate
                v-slot="ProviderProps"
              >
                <input type="text" v-model="settingInfo.cumulative" />
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>基準温度（℃）</dt>
            <dd>
              <ValidationProvider
                rules="required|customDoubleWeather"
                immediate
                v-slot="ProviderProps"
              >
                <input type="text" v-model="settingInfo.basetemp" />
                <p id="item-discription">
                  平均気温が基準温度より高い場合、基準温度を平均気温から引いて積算します。
                </p>
                <p id="item-discription">
                  平均気温が基準温度より低い場合、積算しません。
                </p>
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>気温補正値（℃）</dt>
            <dd>
              <ValidationProvider
                rules="required|customDoubleWeather"
                immediate
                v-slot="ProviderProps"
              >
                <input type="text" v-model="settingInfo.correction" />
                <p id="item-discription">
                  平均気温に気温補正値を加算して積算します。
                </p>
                <p id="item-discription">
                  例：平均気温が20℃、基本補正値が2℃の場合、22℃を積算します。気温補正値が-2℃の場合、18℃を積算します。
                </p>
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
        </div>
      </div>
      <div id="button-area">
        <div class="left-box" />
        <div class="center-box">
          <span
            v-if="viewMode === 'e'"
            class="btn btn-submit"
            :class="{
              active: true,
              disable: ObserverProps.invalid || isReadOnly,
            }"
            @click="update"
            >保存</span
          >
          <span
            v-else
            class="btn btn-submit"
            :class="{
              active: true,
              disable: ObserverProps.invalid || isReadOnly,
            }"
            @click="insert"
            >登録</span
          >
          <span class="btn btn-cancel" @click="onCancel">キャンセル</span>
        </div>
        <div class="right-box">
          <span
            v-if="viewMode === 'e'"
            class="text"
            :class="{ 
              active: !isReadOnly,
              disabled: isReadOnly 
            }"
            @click="onDelete"
            >削除</span
          >
        </div>
      </div>
      <div class="footer"/>
    </validation-observer>
  </div>    
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";
import Dialog from "@/mixins/dialog";
import BigNumber from "bignumber.js";

export default {
  mixins: [Loader, Dialog],

  props: {
    viewMode: {
      type: String,
      default: "a",
    },
    setting_id: Number,
  },

  data() {
    return {
      settingInfo: {},
      isReadOnly: false,
    };
  },

  mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      await this.show();
    });
  },

  methods: {
    ...mapActions([
      "retrieveWeatherSettings",
      "insertWeatherSettings",
      "updateWeatherSettings",
      "deleteWeatherSettings",
    ]),
    ...mapGetters(["isPastManagement"]),

    async show() {
      try {
        if (this.viewMode === "e") {
          const ret = await this.retrieveWeatherSettings(this.setting_id);
          this.isReadOnly = this.isPastManagement();
          if (!ret.length === 0) {
            this.settingInfo.basetemp = 0;
            this.settingInfo.correction = 0;
            return;
          }
          this.settingInfo = ret[0];
        } else {
          this.isReadOnly = this.isPastManagement();
          this.settingInfo.basetemp = 0;
          this.settingInfo.correction = 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async insert() {
      let params = this.settingInfo;
      try {
        this.converNumber(params);
        await this.insertWeatherSettings(params);
        this.$router.push({ name: "weather-settings-show" });
      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      let params = this.settingInfo;
      try {
        this.converNumber(params);
        await this.updateWeatherSettings(params);
        this.$router.push({ name: "weather-settings-show" });
      } catch (error) {
        console.log(error);
      }
    },
    async onDelete() {
      this.showConfirm("削除しますか？", async () => {
        this.loading(async () => {
          try {
            await this.deleteWeatherSettings(this.setting_id);
            this.$router.push({ name: "weather-settings-show" });
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    onCancel: function () {
      this.$router.push({ name: "weather-settings-show" });
    },
    converNumber: function (params) {
      let val = new BigNumber(params.cumulative);
      params.cumulative = val.toNumber();
      val = new BigNumber(params.correction);
      params.correction = val.toNumber();
      val = new BigNumber(params.basetemp);
      params.basetemp = val.toNumber();
    },
  },
};
</script>

<style lang="scss">
.weather-settings-add {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 50%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;

      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: 170px 1fr;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }

      /* フォーム */

      input[type="text"],
      input[type="date"],
      input[type="number"] {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 16px;
        font-size: 16px;
        outline: none;
      }

      input[type="text"]:focus,
      input[type="date"]:focus,
      input[type="number"]:focus {
        background: var(--purple-tertiary);
      }

      select {
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 38px 0 16px;
        font-size: 16px;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center;
        background-size: 25px 25px;
      }

      select:focus {
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center var(--purple-tertiary);
        background-size: 25px 25px;
      }

      textarea {
        font-size: 16px;
        width: 100%;
        min-height: 200px;
        white-space: pre-wrap;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: solid 1px var(--purple);
        padding: 10px;
        border-radius: 10px 10px 0 10px;
      }

      textarea:focus {
        background: var(--purple-tertiary);
      }

      input[type="radio"] {
        display: none;
      }
      input[type="radio"] + label {
        padding: 0 20px 0 0;
      }
      input[type="radio"]:disabled + label {
        color: #aaa;
      }

      input[type="radio"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="radio"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center left;
        background-size: 24px 24px;
        display: inline-block;
      }
      input[type="radio"]:disabled + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
          center left;
        background-size: 24px 24px;
        display: inline-block;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }
    }
  }
  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .right-box {
      right: 0;
      bottom: 0;
      width: 25%;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 50%);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 25%;
      .mobile & {
        width: unset;
      }
    }
    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 10px;
        margin-right: 10px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
      width: 130px;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text.disabled {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  .footer {
    height: 20px;
  }

  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_wb-sunny.svg") no-repeat center center;
  }
  // .btn-submit {
  //   display: block;
  //   background: var(--purple);
  //   font-size: 14px;
  //   text-align: center;
  //   width: 100px;
  //   height: 30px;
  //   border-radius: 15px;
  //   color: #fff;
  //   padding: 6px 20px;
  //   margin: 10px auto 10px;
  //   cursor: pointer;
  //   &.disable {
  //     opacity: 0.5;
  //     cursor: inherit;
  //   }
  // }
  #item-discription {
    margin: 0.25rem 0 0 1rem;
    font-size: 0.8rem;
  }
}
</style>
